import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ParkingGateCodesDashboardQueryKeys } from "modules/ParkingGateCodesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ParkingGateCode } from "models";

export const useCreateParkingGateCodeMutation = () =>
  useTypedMutation<ParkingGateCode, number>({
    mutationFn: async payload => (await ApiInstance.post("/parking_gate/code/create", payload, ENV.dealerBaseURL)).data.parking_gate_code_id,
    onSuccess: (payload, parking_gate_code_id) => {
      const parkingGateCodes = typedQueryClient.getQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes);

      const parkingGateCodeIdx = parkingGateCodes?.findIndex(pgc => pgc.id === parking_gate_code_id) ?? -1;
      if (parkingGateCodeIdx > -1) return;

      typedQueryClient.setQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes, [...(parkingGateCodes || []), { ...payload, id: parking_gate_code_id }]);
    }
  });
